<template>
    <div>

        <sc-text tag="h4" :field="fields.heading" />

        <div class="tab-media" v-if="fields.media">
            <sc-rich-text :field="fields.media" />
        </div>

        <div class="tab-rules">
            <div class="rule" v-if="fields.difficulty">
                <span class="icon difficulty"></span>
                <div>Difficulty: <sc-text :field="fields.difficulty" /></div>
            </div>
            <div class="rule" v-if="fields.players">
                <span class="icon players"></span>
                <div>Players: <sc-text :field="fields.players" /></div>
            </div>
            <div class="rule" v-if="fields.aim">
                <span class="icon aim"></span>
                <div>Aim: <sc-text :field="fields.aim" /></div>
            </div>
            <div class="rule" v-if="fields.scoring">
                <span class="icon scoring"></span>
                <div>Scoring: <sc-text :field="fields.scoring" /></div>
            </div>
        </div>
        <div class="tab-content">
            <sc-rich-text :field="fields.content" />
        </div>
        
    </div>
</template>

<script>
    import { Text, RichText } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'PageTabContent',
  components: {
      ScText: Text,
      ScRichText: RichText
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
